export default "__VITE_ASSET__76b2b59c__"